import React, { Component, useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import Form from "../Comman/Form";
import { Modal, Button } from "react-bootstrap";
import http from "../../Services/httpService";
import config from "../../config.json";
import Joi from "joi-browser";
import SignaturePad from "react-signature-canvas";
import Swal from "sweetalert2";
import publicIp from "react-public-ip"
import { getAlert } from "../../Services/appAlerts";
import { saveBprmForm } from "../../app/store/bprmForm";
import { formatTotalHours, getAllMonths, getAllYears, getFieldData, getMonthLastDay, getMonthName, getTotalHours } from "../../Services/appService";
import { getCurrentUser, getLoggedUserDetails, getUserProfileLogo, loadUserDetails } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getGenerateBulkInvoiceStatus, getPartnerCandidatesReport, loadPartnerAllCandidateRpt, partnerCandidateGenerateBulkInv, partnerCandidatesInvGenerated } from "../../app/store/partner";
import { generatedInvoiePdfReceived, getGeneratedInvPdf, printGeneratedInvoice } from "../../app/store/timeLogInvoice";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../../app/store/candidate";
import Moment from "react-moment";

const BulkInvoice = (props) => {

  const { bulkShowHide, handleBulkShowHide } = props;

  const [partType, setPartType] = useState("recruiter");
  const [ddName, setDdName] = useState("recruiterenrollmentform");
  const [ipAddress, setIpAddress] = useState("");
  const [rate, setRate] = useState(0);
  const [partnerId, setPartnerId] = useState(0);
  const [esignName, setEsignName] = useState("");
  const [candidateObj, setCandidateObj] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [isGenerated, setIsGenerated] = useState(false);
  const [pdfBtnProccess, setPdfBtnProccess] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [generateCount, setGenerateCount] = useState(0);
  const [wfTask, setWfTask] = useState(null);
  const [logoPicObj, setLogoPicObj] = useState(null);

  const months = getAllMonths();
  const years = getAllYears();

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appTasksSelector = useSelector(getAppTasks);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const partnerCandidatesReportSelector = useSelector(getPartnerCandidatesReport);
  const generatedInvPdfSelector = useSelector(getGeneratedInvPdf);
  const generateBulkInvoiceStatusSelector = useSelector(getGenerateBulkInvoiceStatus);
  const userProfilePicSelector = useSelector(getUserProfileLogo);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  const printBodyRef = useRef();
  const printFooterRef = useRef();

  useEffect(() => {
    if (!bulkShowHide) {
      setSelectedYear("");
      setSelectedMonth("");
      setCandidateList([]);
    }
  }, [bulkShowHide]);

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (!userDetailsSelector)
      dispatch(loadUserDetails(usrId));

    const loadIpAddress = async () => {
      const ipv4 = await publicIp.v4() || "";
      setIpAddress(ipv4);

    }
    loadIpAddress();
  }, [])

  useEffect(() => {
    if (userProfilePicSelector) {
      setLogoPicObj(userProfilePicSelector);
    }
  }, [userProfilePicSelector])

  useEffect(() => {
    if (userDetailsSelector) {
      if (userDetailsSelector?.partnerType === "Sub-Contractors") {
        setPartType("subcontractor");
        setDdName("subcontractorenrollmentform");
      }
      setPartnerId(userDetailsSelector.partnerid);
      setUserDetails(userDetailsSelector);
    }
  }, [userDetailsSelector]);


  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (candidateAppsSelector?.length === 0 && currentUser?.id > 0)
      dispatch(loadCandidateApps(usrId));
  }, []);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        if (appTasksSelector.length === 0)
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
      if (filterTasks.length > 0) {
        const reviewTasks = filterTasks.filter(x => x.registrationType === "WP");
        if (reviewTasks.length > 0)
          setWfTask(reviewTasks[reviewTasks.length - 1]);
        else
          setWfTask(filterTasks[0]);
      }
    }
  }, [appTasksSelector]);

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <p>
        {new Date(first.start).toLocaleDateString()} -{" "}
        {new Date(lastDate).toLocaleDateString()}
      </p>
    );
  };

  const getAdjustmentAmout = (item) => {
    const adjMinus = parseFloat(item?.timeLogInvoice?.adjustmentMinues || 0);
    const adjPlus = parseFloat(item?.timeLogInvoice?.adjustmentPlus || 0);
    const adpDeduction = parseFloat(item?.timeLogInvoice?.adpDeduction || 0);

    // Calculate final adjustment
    const adjustment = -adjMinus + adjPlus - adpDeduction;

    return <span>{adjustment.toFixed(2)}</span>;
  };


  const getFinalAmout = (item, usrType) => {
    let rate = getCandidateRate(item, usrType);
    let fAmt = getTotalHours(item?.timeLog?.workingHrs) * rate;
    return parseFloat(fAmt).toFixed(2);
  };

  const getFinalPay = (item, usrType) => {
    const rate = getCandidateRate(item, usrType);

    // Base pay: total hours × rate
    const totalHours = getTotalHours(item?.timeLog?.workingHrs);
    let finalAmount = totalHours * rate;

    // Retrieve adjustments safely
    const adjMinus = parseFloat(item?.timeLogInvoice?.adjustmentMinues || 0);
    const adjPlus = parseFloat(item?.timeLogInvoice?.adjustmentPlus || 0);
    const adpDeduction = parseFloat(item?.timeLogInvoice?.adpDeduction || 0);

    // Apply ALL adjustments
    finalAmount = finalAmount - adjMinus + adjPlus - adpDeduction;

    return finalAmount.toFixed(2);
  };


  const getCandidateRate = (item, type) => {
    let rate = 0;
    if (type === "subcontractor") rate = item?.rate?.subcontractorRate;
    if (type === "recruiter") rate = item?.rate?.recruiterRate;
    return rate;
  };

  const handleInvGenerate = (type) => {
    if (isGenerated) {
      setSelectedCandidates([]);
      setIsGenerated(false);
    } else {
      if (type === "close") {
        handleBulkShowHide("")
      } else {
        setIsGenerated(true);
      }
    }
  };

  const doSubmit = () => {
    dispatch(loadPartnerAllCandidateRpt(selectedYear, selectedMonth, partnerId, partType, 0))
  };

  useEffect(() => {
    setCandidateList(partnerCandidatesReportSelector);
    if (partnerCandidatesReportSelector.length > 0) {
      setCandidateObj(partnerCandidatesReportSelector[0]);
    }
  }, [partnerCandidatesReportSelector]);

  const handleSelectCandidates = (item) => {
    const obj = selectedCandidates.filter((x) => x.id === item.id);
    const candList = [...selectedCandidates];
    if (obj.length > 0) {
      const filterCandidates = selectedCandidates.filter(
        (x) => x.id !== item.id
      );
      setSelectedCandidates(filterCandidates);
    } else {
      candList.push(item);
      setSelectedCandidates(candList)
    }
  };

  const getSubTotals = (selectedCandidates, usrType) => {
    const total = selectedCandidates.reduce((acc, item) => {
      const fAmt = parseFloat(getFinalPay(item, usrType)) || 0;
      return acc + fAmt;
    }, 0);

    return parseFloat(total).toFixed(2);
  };

  const handlePrintPdf = async () => {
    setPdfBtnProccess(true)
    let htmlBody = printBodyRef.current.innerHTML;
    htmlBody += printFooterRef.current.innerHTML;
    if (logoPicObj) {
      const imgElement = await getEmergencyFoundImg(
        process.env.REACT_APP_API_BASEURL + "/CompanyLogo/" + logoPicObj
      );

      if (imgElement) {
        htmlBody =
          "<div style='text-align:left;padding-bottom:10px'>" +
          imgElement.outerHTML + "</img>" +
          "</div>" + htmlBody;
      }


    }
    const frmData = new FormData();
    frmData.append("html", htmlBody);
    dispatch(printGeneratedInvoice(frmData));
  };

  useEffect(() => {
    if (generatedInvPdfSelector?.size > 0) {
      setPdfBtnProccess(false);
      dispatch(generatedInvoiePdfReceived(null))
      const url = window.URL.createObjectURL(generatedInvPdfSelector);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [generatedInvPdfSelector])

  const handleSaveGenerate = () => {
    setSaveBtnProccess(true);
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    let newFilter = [...candidateList];
    selectedCandidates.map(async (item, key) => {
      newFilter = newFilter.filter(x => x.id !== item.id);
      const newList = [item];
      let htmlBody = getUpdatedHtml(newList);
      htmlBody += printFooterRef.current.innerHTML;
      //let htmlBody = printBodyRef.current.innerHTML;
      // wait for getEmergencyFoundImg to resolve
      if (logoPicObj) {
        const imgElement = await getEmergencyFoundImg(
          process.env.REACT_APP_API_BASEURL + "/CompanyLogo/" + logoPicObj
        );

        if (imgElement) {
          htmlBody =
            "<div style='text-align:left;padding-bottom:10px'>" +
            imgElement.outerHTML + "</img>" +
            "</div>" + htmlBody;
        }

      }

      const frmData = new FormData();
      frmData.append("html", htmlBody);
      frmData.append("candidate", JSON.stringify(item));
      frmData.append("sign", "");
      frmData.append("remarks", "Invoice");
      frmData.append("userId", usrId);
      frmData.append("invNum", "");
      frmData.append("workflowTask", JSON.stringify(wfTask));
      dispatch(partnerCandidateGenerateBulkInv(frmData));
      setGenerateCount(key + 1);
    });
  };

  useEffect(() => {
    if (generateBulkInvoiceStatusSelector && generateCount === candidateList.length) {
      setSaveBtnProccess(false);
      getAlert("", "Generated and Sent Successfully", "success");
      setGenerateCount(0);
      dispatch(partnerCandidatesInvGenerated(false));
      setCandidateList([]);
      setIsGenerated(false);
      setEsignName("");
    }
  }, [generateBulkInvoiceStatusSelector])

  const getUpdatedHtml = (newList) => {
    const inv1 = getInvoiceHeader(newList[0]);
    const inv2 = getInvoiceInfo();
    const inv3 = getInvoiceMain(newList);
    const invHtml1 = ReactDOMServer.renderToStaticMarkup(inv1);
    const invHtml2 = ReactDOMServer.renderToStaticMarkup(inv2);
    const invHtml3 = ReactDOMServer.renderToStaticMarkup(inv3);
    const htmlBody = invHtml1 + invHtml2 + invHtml3;
    return htmlBody;
  };

  const getInvoiceBody = (selectedCandidates) => {

    const borderCss = {
      border: "1px solid #ccc",
      borderTop: "0px",
      borderRight: "0px",
      paddingTop: "3px",
      paddingBottom: "3px"
    };

    const tbdy = (
      <tbody style={{ fontSize: "12px" }}>
        {selectedCandidates.map((item) => (
          <tr>
            <td style={borderCss}>{item.name} {" "}
              {getFieldData(
                item.performerData,
                "candidateonboardingform",
                "Last_Name"
              )}
            </td>
            <td style={borderCss}>{getMonthlyPeriod(item?.timeLog)}</td>
            <td align="right" style={borderCss}>
              {formatTotalHours(item?.timeLog?.workingHrs)}
            </td>
            <td align="right" style={borderCss}>
              {getCandidateRate(item, partType)}
            </td>
            <td align="right" style={borderCss}>
              {getFinalAmout(item, partType)}
            </td>
            <td align="right" style={borderCss}>
              {getAdjustmentAmout(item)}
            </td>
            <td align="right" style={borderCss}>
              {getFinalPay(item, partType)}
            </td>
          </tr>
        ))}
      </tbody>
    );

    return tbdy;
  };

  const getInvoiceHeader = (obj) => {
    const canObj = selectedCandidates.filter(x => x.id === obj.id)[0];
    return (
      <table
        width="100%"
        cellPadding="5"
        cellSpacing="0"
        border="0"
        style={{ borderBottom: "1px solid #ccc", marginBottom: "25px" }}
      >
        <tr>
          <td align="left" colSpan={2}>
            <p>
              <span hidden="true"></span>
            </p>
          </td>
          <td colSpan={2} align="right">
            <p
              style={{
                fontSize: "30px",
                fontWeight: "bold",
                padding: "2px",
                color: "#4646EE"
              }}
            >
              INVOICE
            </p>
          </td>
        </tr>
        <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
          <td width="50%"></td>
          <td width="20%" valign="top">Invoice Number</td>
          <td width="1%">:</td>
          <td style={{ textAlign: "right", whiteSpace: "warp" }}>
            {canObj?.invoiceNumber}
          </td>
        </tr>
        <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
          <td></td>
          <td>Invoice Date</td>
          <td>:</td>
          <td align="right">{new Date().toLocaleDateString()}</td>
        </tr>
        <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
          <td></td>
          <td>Payment Term</td>
          <td>:</td>
          <td align="right"> Net 30 Days</td>
        </tr>

        <tr>
          <td colSpan={4} style={{ paddingTop: "10px" }}>
            <p></p>
          </td>
        </tr>
      </table>
    );
  };

  const getEmergencyFoundImg = (url) => {
    return new Promise((resolve) => {
      const img = new Image();

      // Set CORS before src
      img.crossOrigin = "anonymous";
      img.src = url;

      img.onload = () => {
        const c = document.createElement("canvas");
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;

        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0);

        try {
          const base64String = c.toDataURL("image/png");

          const img2 = document.createElement("img");
          img2.src = base64String;
          img2.style.height = "90px";
          img2.style.width = "auto";
          img2.style.borderRadius = "10px";
          img2.style.marginBottom = "5px";

          resolve(img2);
        } catch (e) {
          // In case of toDataURL failure, return empty string
          resolve('');
        }
      };

      // Instead of rejecting, resolve with empty string on error
      img.onerror = () => {
        resolve('');
      };
    });
  };


  const getInvoiceInfo = () => {
    return (
      <table
        cellPadding="5"
        cellSpacing="0"
        width="100%"
        border="0"
        style={{ marginBottom: "25px" }}
      >
        <tbody>
          <tr>
            <td
              style={{ fontSize: "17px", fontWeight: "bold", backgroundColor: "rgb(236 236 244)" }}
              width="51%"
            >
              {userDetails && getFieldData(
                userDetails.performerData,
                ddName,
                "Company_Name"
              )}
            </td>
            <td
              style={{
                fontSize: "17px",
                fontWeight: "bold",
                backgroundColor: "rgb(214 214 241)",
                border: "1px solid #ccc",
              }}
            >
              Bill To/Ship To
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", fontSize: "14px", marginBottom: "2px", backgroundColor: "rgb(214 214 241)" }}>
              {userDetails && (
                <React.Fragment>
                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Address_Line1"
                    )}
                  </p>
                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_City"
                    )}
                    ,{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_State"
                    )}{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Zip_Code"
                    )}
                  </p>

                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>
                    Federal ID :{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Federal_ID"
                    )}
                  </p>
                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>
                    Phone :{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Phone_Code"
                    )}{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Phone"
                    )}
                  </p>
                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>
                    Email ID :{" "}
                    {getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Email"
                    )}
                  </p>
                  <p style={{
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}>ID : {partnerId}</p>
                </React.Fragment>
              )}
            </td>
            <td style={{ border: "1px solid #ccc", fontSize: "14px", marginBottom: "2px", backgroundColor: "rgb(236 236 244)" }} valign="top">
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>
                International Projects Consultancy Services (IPCS) Inc.
              </p>

              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>600 Highway 169 South</p>
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>METROPOINT, Suite 1595</p>
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>Minneapolis, MN 55426</p>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const getBankDetails = () => {

    return (
      <table
        cellPadding="5"
        cellSpacing="0"
        width="100%"
        border="0"
        style={{ marginBottom: "25px" }}
      >
        <tbody>
          <tr>
            <td
              style={{
                fontSize: "17px",
                fontWeight: "bold",
                border: "1px solid #ccc",
                backgroundColor: "rgb(236 236 244)"
              }}
            >
              Make Payment To
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", fontSize: "14px", marginBottom: "2px", backgroundColor: "rgb(236 236 244)" }} valign="top">
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>
                Bank Name :{" "}
                {getFieldData(
                  candidateObj.partnerStateData,
                  "achinfo",
                  "Bank_Name"
                )}
              </p>
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>
                Routing Number :{" "}
                {getFieldData(
                  candidateObj.partnerStateData,
                  "achinfo",
                  "Routing"
                )}
              </p>
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>
                Account Number :{" "}
                {getFieldData(
                  candidateObj.partnerStateData,
                  "achinfo",
                  "Account_No"
                )}
              </p>
              <p style={{
                paddingTop: "2px",
                paddingBottom: "2px"
              }}>
                Email Notification To :{" "}
                {getFieldData(
                  candidateObj.partnerStateData,
                  "achinfo",
                  "Email"
                )}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const getInvoiceFotter = () => {
    return (
      <div>
        {/* <p style={{ fontWeight: "bold", paddingBottom: "5px" }}>Signature</p> */}
        <p style={{
          fontStyle: "italic", fontWeight: "bold",
          fontSize: "14px", marginBottom: "3px", marginTop: "13px"
        }}>{esignName}</p>
        <p style={{ fontSize: "14px", marginBottom: "3px" }}>{new Date().toUTCString()}</p>
        <p style={{ fontSize: "14px", marginBottom: "3px" }}>IP Address : {ipAddress}</p>
        <p style={{ fontSize: "14px", marginBottom: "3px" }}>
          Name : {userDetails?.performername} {userDetails?.lastName}
        </p>

      </div>
    );
  };

  const getInvoiceMain = (selectedCandidates) => {

    const borderCss = {
      border: "1px solid #ccc",
      borderTop: "0px",
      borderRight: "0px",
      paddingTop: "3px",
      paddingBottom: "3px"
    };
    return (
      <React.Fragment>
        <table
          cellPadding="2"
          cellSpacing="0"
          width="100%"
          style={{
            border: "1px solid #ccc",
            borderBottom: "0px",
            borderLeft: "0px",
            marginBottom: "45px",
          }}
        >
          <thead style={{ backgroundColor: "#f0f0f0", fontSize: "12px" }}>
            <tr>
              <th style={borderCss}>Candidate Name</th>
              <th style={borderCss}>Period</th>
              <th style={borderCss}>Hours</th>
              <th style={borderCss}>Rate/hr ($)</th>
              <th style={borderCss}>Invoice Amount ($)</th>
              <th style={borderCss}>Adjustment ($)</th>
              <th style={borderCss}>Final Amount ($)</th>
            </tr>
          </thead>
          {getInvoiceBody(selectedCandidates)}
          <tbody style={{ fontSize: "12px" }}>
            <tr>
              <td colSpan={6} align="right" style={borderCss}>
                SubTotal
              </td>
              <td align="right" style={borderCss}>
                {getSubTotals(selectedCandidates, partType)}
                {/* {getFinalPay(selectedCandidates, partType)} */}
              </td>
            </tr>
            <tr>
              <td colSpan={6} align="right" style={borderCss}>
                Total
              </td>
              <td align="right" style={borderCss}>
                {getSubTotals(selectedCandidates, partType)}
                {/* {getFinalPay(selectedCandidates, partType)} */}
              </td>
            </tr>
          </tbody>
        </table>
        <table
          cellPadding="2"
          cellSpacing="0"
          width="100%"
          style={{
            border: "1px solid #ccc",
            borderBottom: "0px",
            borderLeft: "0px",
            marginBottom: "85px",
          }}
        >
          <tbody style={{ fontSize: "12px" }}>
            <tr>
              <td
                width="15%"
                style={{
                  border: "1px solid #ccc",
                  borderTop: "0px",
                  borderRight: "0px",
                  fontWeight: "bold",
                  backgroundColor: "#f0f0f0",
                }}
              >
                Service
              </td>
              <td
                style={{
                  border: "1px solid #ccc",
                  borderTop: "0px",
                  borderRight: "0px",
                }}
              >
                As per IT consulting services agreement and purchase order
              </td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  };

  const handleSelect = ({ currentTarget }) => {
    const id = currentTarget.dataset.obj;
    const obj = candidateList.filter((x) => x.id === parseInt(id))[0];
    if (currentTarget.checked) {
      if (!obj.invoiceNumber) {
        getAlert("", "Please Enter Invoice Number", "error");
        currentTarget.checked = false;
      } else handleSelectCandidates(obj);
    } else {
      handleSelectCandidates(obj);
    }
  };

  const handleChangeInvNumber = ({ currentTarget }) => {
    const id = currentTarget.dataset.obj;
    const obj = { ...candidateList.filter((x) => x.id === parseInt(id))[0] };
    const index = candidateList.findIndex(x => x.id === parseInt(id));
    const candList = [...candidateList];
    if (obj) {
      obj.invoiceNumber = currentTarget.value;
      candList[index] = obj;
      setCandidateList(candList);
    }
  }

  return (
    <React.Fragment>
      <Modal show={bulkShowHide} size="xl">
        <Modal.Header closeButton onHide={() => handleInvGenerate("close")}>
          <Modal.Title>Generate Bulk Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border pl-6 pr-6">
          <div className="row">
            {!isGenerated && (
              <React.Fragment>
                <div className="col-md-4">
                  <label htmlFor="year" className="form-control-label">Invoice Year</label>
                  <select name="year" id="year"
                    className="form-control"
                    value={selectedYear}
                    onChange={({ currentTarget }) => setSelectedYear(currentTarget.value)}
                  >
                    <option value="">Year</option>
                    {years.map(y =>
                      <option value={y.name}>{y.name}</option>
                    )}
                  </select>

                </div>
                <div className="col-md-4">
                  <label htmlFor="month" className="form-control-label">Invoice Month</label>
                  <select name="month" id="month"
                    className="form-control"
                    value={selectedMonth}
                    onChange={({ currentTarget }) => setSelectedMonth(currentTarget.value)}
                  >
                    <option value="">Month</option>
                    {months.map(m =>
                      <option value={m.id}>{m.name}</option>
                    )}
                  </select>

                </div>
                <div className="col-md-4 d-flex align-items-end justify-content-start mb-1">
                  <button
                    className="btn btn-outline-default"
                    disabled={!selectedYear || !selectedMonth}
                    onClick={doSubmit}
                  >
                    Load Candidates
                  </button>
                </div>
                <div className="col-md-12 form-group mt-2">
                  <div className="table-responsive">
                    <table className="table align-items-center table-flush table-hover table-striped border">
                      <thead className="thead-light">
                        <tr>
                          <th>Select</th>
                          <th>Enter Invoice Number</th>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {candidateList.map((item) => (
                          <tr>
                            <td>
                              <input
                                type="checkbox"
                                defaultChecked={item.isSelected}
                                onChange={handleSelect}
                                data-obj={item.id}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={item.invoiceNumber}
                                onChange={handleChangeInvNumber}
                                data-obj={item.id}
                                placeholder="Invoice Number"
                              />
                            </td>
                            <td>{item.id}</td>
                            <td>
                              <span className="text-uppercase font-weight-bold">
                                {item.name} {item.lastName}
                              </span>
                            </td>
                            <td>{item.email}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-md-12 text-center">
                  <button
                    className="btn btn-sm btn-outline-default"
                    disabled={selectedCandidates.length <= 0}
                    onClick={handleInvGenerate}
                  >
                    <i className="fa fa-cog" aria-hidden="true"></i> Generate Invoice
                  </button>
                </div>
              </React.Fragment>
            )}
            {isGenerated && (
              <React.Fragment>
                <div className="col-md-12">
                  <img
                    id="Img1"
                    alt="profileLogo"
                    src={`${process.env.REACT_APP_API_BASEURL}/CompanyLogo/${logoPicObj}`}
                    style={{ height: "150px", marginBottom: "5px", borderRadius: "10px" }}
                  />
                  <div id="printBody" ref={printBodyRef}>
                    {candidateObj && getInvoiceHeader(candidateObj)}
                    {getInvoiceInfo()}
                    {/* {selectedCandidates.length > 0 && getBankDetails()} */}
                    {selectedCandidates.length > 0 &&
                      getInvoiceMain(selectedCandidates)}
                  </div>
                  <div id="printFooter" ref={printFooterRef}>
                    {selectedCandidates.length > 0 && getInvoiceFotter()}
                  </div>
                </div>
                {/* <div className="col-md-12 mt-3 form-group">
                  <label htmlFor="esignName" className="form-control-label">Sign Digitally</label>
                  <textarea cols="2" rows={2}
                    id="esignName"
                    name="esignName"
                    className="form-control"
                    value={esignName}
                    placeholder="Sign Digitally"
                    onChange={({ currentTarget }) => setEsignName(currentTarget.value)}
                  ></textarea>
                </div> */}
                <div className="col-md-12 text-center">
                  <button
                    className="btn btn-sm btn-outline-default"
                    onClick={handleInvGenerate}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i> Close
                  </button>
                  <button
                    className="btn btn-sm btn-outline-default"
                    onClick={handleSaveGenerate}
                  >
                    {saveBtnProccess ? <i className="fa fa-spinner fa-spin mr-2"></i> :
                      <i className="fa fa-check mr-2" aria-hidden="true"></i>}Generate & Save
                  </button>
                  <button
                    className="btn btn-sm btn-outline-default"
                    onClick={handlePrintPdf}
                  >
                    {pdfBtnProccess ? <i className="fa fa-spinner fa-spin mr-2"></i> :
                      <i className="fa fa-print mr-2" aria-hidden="true"></i>}Print PDF
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <button className="btn btn-sm btn-outline-default" onClick={() => handleBulkShowHide("")}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
        </Modal.Footer> */}
      </Modal>
    </React.Fragment>
  );
}

export default BulkInvoice;
